import type { FillLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const BD_ADMINISTRATIVE_DISTRICT_SOURCE_ID = 'administrative-districts';
export const BD_ADMINISTRATIVE_DISTRICT_LAYER_NAME = 'administrative-districts';
export const BD_ADMINISTRATIVE_DISTRICTS_HIGHLIGHTED_LAYER_NAME =
  'administrative-districts-highlighted';

export const BD_ADMINISTRATIVE_DISTRICTS_LAYER_CONFIG: FillLayerSpecification =
  {
    id: BD_ADMINISTRATIVE_DISTRICT_LAYER_NAME,
    type: 'fill',
    source: BD_ADMINISTRATIVE_DISTRICT_SOURCE_ID,
    'source-layer': 'administrative-districts',
    paint: {
      'fill-outline-color': 'rgba(0,0,0,0.3)',
      'fill-color': 'rgba(0,0,0,0.1)',
    },
  };

export const BD_ADMINISTRATIVE_DISTRICTS_LAYER_HIGHLIGHTED_CONFIG: FillLayerSpecification =
  {
    id: BD_ADMINISTRATIVE_DISTRICTS_HIGHLIGHTED_LAYER_NAME,
    type: 'fill',
    source: BD_ADMINISTRATIVE_DISTRICT_SOURCE_ID,
    'source-layer': 'administrative-districts',
    paint: {
      'fill-outline-color': '#484896',
      'fill-color': '#6e599f',
      'fill-opacity': 0.75,
    },
    filter: ['in', 'key', ''],
  };

export const BD_ADMINISTRATIVE_DISTRICTS_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.de-administrative-districts-dev',
};

export interface BD_ADMINISTRATIVE_DISTRICTS_SOURCE_PROPERTIES {
  color: string;
  key: string;
  displayName: string;
}
